import { Pipe, PipeTransform } from '@angular/core';
import { fromCamelCaseToSentence } from '../bb-charts/bb-chart/bb-chart-utils';

@Pipe({
    name: 'camelToSentenceCase',
    standalone: true
})
export class CamelToSentenceCasePipe implements PipeTransform {
    transform(string: string): string {
        return fromCamelCaseToSentence(string);
    }
}
